<template>
    <div id="thirdStep" class="step">
        <div class="fieldset-content">
            <div class="row">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-12 col-lg-6 col-sm-12 control" style="margin-bottom: 15px;">
                            <label for="previewLogo">{{ $t('textTenants.textTittleLogo') }}</label>
                            <div id='previewLogo' class="preview">
                                <div v-if="img_logo != null" class="image-list">
                                    <img class="image" :src="img_logo">
                                </div>
                            </div>
                            <ejs-uploader ref="uploadLogo" id='uploadLogo' name="uploadLogo" :selected="onUploadLogo" :asyncSettings="path" :allowedExtensions="extensions" :multiple='false' :dropArea="dropLogo"></ejs-uploader>
                            <span v-if="logo_message != ''" class="e-error mb-1">* {{logo_message}}</span>
                            <div class='infoBrowser'>
                                <h6>{{ $t('textTenants.infoBrowser.textTittle') }}</h6>
                                <ul>
                                    <li v-for="n in 5" :key="n">{{ $t('textTenants.infoBrowser.textRecomendationLogo' + n) }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-sm-12 control" style="margin-bottom: 15px;">
                            <label for="previewBanner">{{ $t('textTenants.textTittleBanner') }}</label>
                            <div id='previewBanner' class='preview'>
                                <div v-if="img_home != null" class="image-list">
                                    <img class="image" :src="img_home">
                                </div>
                            </div>
                            <ejs-uploader ref="uploadBanner" id='uploadBanner' name="uploadBanner" :selected="onuploadBanner" :asyncSettings="path" :allowedExtensions="extensions"  :multiple='false' :dropArea="dropBanner"></ejs-uploader>
                            <span v-if="banner_message != ''" class="e-error mb-1">* {{banner_message}}</span>
                            <div class='infoBrowser'>
                                <h6>{{ $t('textTenants.infoBrowser.textTittle') }}</h6>
                                <ul>
                                    <li v-for="n in 5" :key="n">{{ $t('textTenants.infoBrowser.textRecomendationBanner' + n) }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row formGroup">
                <div class="col-12 col-lg-12 col-sm-12">
                        <label>Personalizar remitente de correo</label>
                        <div class="alert alert-info" role="alert">
                            Modifica el <b>Nombre</b> y <b>Correo</b> del remitente de los correos que se envían a los usuarios.
                            <br>
                            {{ customEmailName ? `${customEmailName} vía Alinea` : 'Alinea' }} 
                            {{ customEmailUserDomain ? `&lt;${customEmailUserDomain}@legops.com&gt;` : `&lt;alertas@legops.com&gt;` }}
                        </div>
                    <div class="row formRow">
                        <div class="col-12 col-lg-6 col-sm-6 control">
                            <label for="customEmailName">Nombre</label>
                            <ejs-textbox v-model="customEmailName" name="customEmailName" id="customEmailName" type="text" class="form-control"></ejs-textbox>
                        </div>
                        <div class="col-12 col-lg-6 col-sm-6 control">
                            <label for="customEmailUserDomain">Correo</label>
                            <ejs-textbox v-model="customEmailUserDomain" name="customEmailUserDomain" id="customEmailUserDomain" type="text" class="form-control"></ejs-textbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-tenant-footer numberPage='3' numberOfPages='3' previousId="previousStep3" nextId="nextStep3" :save='true'></create-tenant-footer>
    </div>
</template>

<script>
import axios from 'axios';
import { UploaderPlugin, SelectedEventArgs } from '@syncfusion/ej2-vue-inputs';
import { createElement, detach, EventHandler } from '@syncfusion/ej2-base';
Vue.use(UploaderPlugin);

export default {
    name: "create-tenant-third-step",
    data () {
		return {
            path: '',
            img_logo: null,
            img_home: null,
            extensions: '.png, .jpg, .jpeg',
            autoUpload: false,
            dropLogo: '#previewLogo',
            dropBanner: '#previewBanner',
            logo_message: '',
            banner_message: '',
            customEmailName: null,
            customEmailUserDomain: null,
        }
    },
    mounted: function(){
        let uploads = document.getElementsByClassName('e-file-select-wrap');
        let uploadsTittle1 = document.createElement("span");
        let uploadsTittle2 = document.createElement("span");
        uploadsTittle1.setAttribute("class","e-file-drop");
        uploadsTittle2.setAttribute("class","e-file-drop");
        uploadsTittle1.textContent = "o suelta una imagen aquí";
        uploadsTittle2.textContent = "o suelta una imagen aquí";
        uploads[0].append(uploadsTittle1);
        uploads[1].append(uploadsTittle2);
    },
	methods: {
        initEditTenantThirdStep: function() {
            if(!!this.$route.params.id) {
                Vue.prototype.$eventHub.$emit('onShowSpinner');
                axios.post('/auth/tenants/getInitEditTenantThirdStep', {
                    tenantId: this.$route.params.id,
                }).then(response => {
                    this.img_logo = response.data.logo;
                    this.img_home = response.data.img_home;
                    const cfgCustomEmail = response.data.cfg_custom_email || {};
                    this.customEmailName = cfgCustomEmail.email_name || null;
                    this.customEmailUserDomain = cfgCustomEmail.user_domain || null;
                    Vue.prototype.$eventHub.$emit('onHideSpinner');
                });
            }
        },
        onUploadLogo : function(args){
            for(let i = 0; i< args.filesData.length ; i++)
            {
                var objDocument = document.getElementById('previewLogo');
                let liparentDiv = createElement('div',  { className: 'image-list'});
                let liImage = createElement('img',  { className: 'image', id: 'img_logo'});
                liparentDiv.appendChild(liImage);
                this.readURL(liImage, args.filesData[i]);
                objDocument.innerHTML = '';
                objDocument.appendChild(liparentDiv);
            }
            
            setTimeout(() => {
                let foto = new Image();
                foto.src = document.getElementById('img_logo').getAttribute('src');
                // ancho mas grande que alto 4 veces mas 
                let height = (foto.width / 4);
                if(foto.height <= height ){
                    args.cancel=true;
                    this.logo_message = "";
                }else{
                    $("#previewLogo").html(" ");
                    this.logo_message = "El tamaño del logo no es proporcional";
                    this.$refs.uploadLogo.ej2Instances.clearAll();
                }                
            }, 200);
        },
        onuploadBanner: function(args){
            for(let i = 0; i< args.filesData.length ; i++)
            {
                var objDocument = document.getElementById('previewBanner');
                let liparentDiv = createElement('div',  { className: 'image-list'});
                let liImage = createElement('img',  { className: 'image', id: 'img_banner'});
                liparentDiv.appendChild(liImage);
                this.readURL(liImage, args.filesData[i]);
                objDocument.innerHTML = '';
                objDocument.appendChild(liparentDiv);
            }
            
            setTimeout(() => {
                let foto = new Image();
                foto.src = document.getElementById('img_banner').getAttribute('src');
                // ancho mas grande que alto 5 veces mas 
                let height = (foto.width / 4);
                if(foto.height <= height ){
                    args.cancel=true;
                    this.banner_message = "";
                }else{
                    $("#previewBanner").html(" ");
                    this.banner_message = "El tamaño del banner no es proporcional";
                    this.$refs.uploadBanner.ej2Instances.clearAll();
                }                
            }, 200);
        },
        readURL: function(liImage, file) {
            let imgPreview = liImage ;
            let imageFile = file.rawFile;
            let reader = new FileReader();
            reader.addEventListener( 'load', () => {
                imgPreview.src = reader.result;
            }, false);
            if (imageFile) {
                reader.readAsDataURL(imageFile);
            }
        },
        btnClicked: function(args) {
            Vue.prototype.$eventHub.$emit('onChangeTabWizard', args);
        }
	},
	created: function() {
		this.initEditTenantThirdStep();
	},
    watch: {
        customEmailUserDomain: function (val) {
            this.customEmailUserDomain = val.replace(/[^a-zA-Z0-9._-]/g, '').toLowerCase();
        }
    }
}
</script>